import { isWeekend, parse } from "date-fns";

/**
 * Limits a week of yyyy-MM-dd date strings to `daysCount` entries by dropping
 * weekend days first, so a 5-day view always shows the weekdays regardless of
 * which day the week starts on.
 */
export const limitWeekDateStrings = (
  dates: string[],
  daysCount: number
): string[] => {
  if (dates.length <= daysCount) {
    return dates;
  }
  return dates
    .filter((date) => !isWeekend(parse(date, "yyyy-MM-dd", new Date())))
    .slice(0, daysCount);
};
